import ArchitectureDesignForm from "../component/ArchitectureDesignForm";

const CommercialArchitectureDesignEdit = () => {
  return <ArchitectureDesignForm isEditMode={true} />;
};

export default CommercialArchitectureDesignEdit;
